'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHstc = getHstc;
exports.getUtk = getUtk;
exports.getUtkAsync = getUtkAsync;
exports.getUuid = getUuid;
exports.stashUuid = stashUuid;

var _cookieHelper = require('pricing-pages-unified-ui/utils/cookieHelper');

var cookieHelper = _interopRequireWildcard(_cookieHelper);

var _params = require('hub-http/helpers/params');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getHstc() {
  return cookieHelper.get('__hstc');
}

function getUtk() {
  var utk = cookieHelper.get('hubspotutk');
  if (!utk) {
    utk = getHstc();
    if (utk) {
      utk = utk.split('.')[1];
    }
  }
  return utk || null;
}

/* eslint-disable */
function getUtkAsync() {
  return new Promise(function (resolve) {
    var interval = void 0;
    interval = setInterval(function () {
      var utk = getUtk();
      if (utk) {
        clearInterval(interval);
        resolve(utk);
      }
    }, 200);
  });
}
/* esline-enable */

function getUuid() {
  var query = (0, _params.parse)(location.search.replace('?', '') || '');
  var uuidFromQuery = query.luid;
  var uuidFromCookies = cookieHelper.get('luid');
  return uuidFromCookies || uuidFromQuery;
}

function stashUuid(history) {
  var uuid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  // Save to cookies once we know user has accepted cookies
  if (!cookieHelper.get('luid')) {
    getUtkAsync().then(function () {
      cookieHelper.set('luid', uuid);
    });
  }

  // Save to query params as fallback when cookies arn't an option
  var query = (0, _params.parse)(location.search.replace('?', '') || '');
  if (!query.luid) {
    var search = location.search.indexOf('?') !== -1 ? location.search + '&luid=' + uuid : '?luid=' + uuid;
    history.replace({ search: search });
  }
}


//////////////////
// WEBPACK FOOTER
// ./js/utils/identityHelper.js
// module id = 890
// module chunks = 4